import type { AssetGroup } from '@/types/asset';
import { atom } from 'jotai';

/** Set by the sidebar while its board links are on screen, so assets are only draggable when there's somewhere to drop them. */
export const sidebarBoardDropEnabledAtom = atom(false);

export const draggedAssetAtom = atom<AssetGroup | null>(null);
